import { action, computed, observable } from 'mobx'
import { $RootStore } from '../RootStore'
import { BaseSetupStore, PlatformStepData } from '../../../shared-solo/stores/SetupStore/BaseSetupStore'
import { SetupStep, ToastData } from 'shared-solo/stores/SetupStore/stepData/d'
import setupTasksData from 'shared-solo/stores/SetupStore/setupTasksData'
import { stepData } from './stepData'
import { DropdownAlertType } from '../DropdownMessageHandler'
import icons from '../../assets/icons'
import TextButton from '../../components/TextButton'

class SetupStore extends BaseSetupStore {
  @observable accessor isModalOpen = false
  @observable accessor activeStepId: string | null = null

  @action openModal = () => {
    this.isModalOpen = true
  }

  @action closeModal = () => {
    this.activeStepId = null
    this.isModalOpen = false
  }

  @action openStepDrawer = (stepId: string) => {
    this.activeStepId = stepId
  }

  @action closeStepDrawer = () => {
    this.activeStepId = null
  }

  onStepSetup = () => {
    this.closeModal()
  }

  onStepSkip = () => {}

  getPlatformStepData(): PlatformStepData[] {
    return stepData
  }

  onTap = () => {
    this.openModal()
  }

  openURL = (url: string) => {
    window.open(url, '_blank')
  }

  showStepCompletedToast = (toastData: ToastData) => {
    const { s } = this.rootStore.i18n
    this.rootStore.dropdownMessageHandler.showDropdownMessage({
      message: toastData.title,
      icon: icons.tick,
      onTap: this.onTap,
      type: 'contrast-success' as DropdownAlertType,
      closeInterval: 5000,
      showProgressAnimation: true,
      priority: 1,
      sx: {
        py: 3,
        pl: 5,
        pr: 9,
      },
      actionComponent: <TextButton onClick={() => this.onTap()}>{s('Continue setting up')}</TextButton>,
    })
  }

  showTaskCompletedPopup = ({
    relatedTask,
    bottomMessageHandler,
  }: {
    relatedTask: (typeof setupTasksData)[number]
    navigationStore: $RootStore['navigationStore']
    bottomMessageHandler: $RootStore['bottomMessageHandler']
  }) => {
    const { body = '' } = relatedTask.successPopupData || {}

    bottomMessageHandler.showBottomMessage({
      title: 'Setup completed',
      body,
      icon: {
        type: 'circleIcon',
        iconName: 'tick',
        color: 'green',
      },
      actions: [
        {
          type: 'RectButton',
          title: "See what's next",
          rectButtonSize: 'medium',
          onPress: () => {
            bottomMessageHandler.hideBottomMessage()
            this.openModal()
          },
        },
        {
          type: 'TextButton',
          title: 'Dismiss',
          onPress: () => {
            bottomMessageHandler.hideBottomMessage()
          },
        },
      ],
    })
  }

  @computed get badgeCount() {
    if (!this.gettingStartedFirstStepsComplete) {
      return this.remainingGettingStartedSteps.length
    }
    return this.remainingTasks.length
  }

  showStepModalPopup = ({
    step,
  }: {
    step: SetupStep
    isRequiredStep: boolean
    isDev: boolean
    bottomMessageHandler: $RootStore['bottomMessageHandler']
    onSetup: () => void
    onSkip: () => void
  }) => {
    this.openStepDrawer(step.id)
  }
}

export default SetupStore